// @flow

import ko from 'rgs-knockout';

import 'ko-component-btn-radio-group';
import 'ko-component-fio-input';
import 'ko-component-person-identity-document-editor';
import 'ko-component-file-upload-input';

import Model from './js/model';
import template from './templates/template.html';

ko.components.register('myrgs-auth-form', {
	viewModel: Model,
	template: template(),
});

export type { MyrgsFormModelParams, ValidationMode } from './js/model';
export default Model;
